import { useTranslation } from 'react-i18next';

import Breadcrumbs from '~/components/Breadcrumbs/Breadcrumbs';
import { useGlobal } from '~/hooks/useGlobal';
import type { BreadcrumbsItem } from '~/stores/CatalogStore';

import MobileHeaderLayout from '../../Main/MobileHeader/MobileHeaderLayout';
import MobileHeaderTitle from '../../Main/MobileHeader/MobileHeaderTitle';

import tp from '../textPage.module.scss';
import styles from './ReturnsPage.module.scss';

const content = {
  ru: {
    conditionsTitle: 'Условия возврата',
    conditionsText:
      'Вы можете вернуть товар в течение 14 дней после получения.',
    howTitle: 'Как оформить возврат',
    howSteps: [
      'Свяжитесь со службой поддержки',
      'Упакуйте товар в оригинальную упаковку',
      'Отправьте товар по указанному адресу',
    ],
    refundTitle: 'Возврат средств',
    refundText:
      'Деньги возвращаются на карту в течение 5-7 рабочих дней после получения товара на складе.',
    exchangeTitle: 'Обмен товара',
    exchangeText:
      'Обмен возможен на товар аналогичной стоимости в течение 14 дней.',
    importantTitle: 'Важно',
    importantText:
      'Товар должен быть в оригинальной упаковке, с биркой и без следов использования.',
  },
  en: {
    conditionsTitle: 'Return Conditions',
    conditionsText: 'You can return an item within 14 days of receipt.',
    howTitle: 'How to Request a Return',
    howSteps: [
      'Contact our support team',
      'Pack the item in its original packaging',
      'Ship the item to the specified address',
    ],
    refundTitle: 'Refunds',
    refundText:
      'Refunds are credited to your card within 5–7 business days after the item is received at our warehouse.',
    exchangeTitle: 'Exchanges',
    exchangeText:
      'Exchanges for an item of equal value are available within 14 days.',
    importantTitle: 'Important',
    importantText:
      'The item must be in its original packaging, with tags attached, and show no signs of use.',
  },
};

const ReturnsPage = () => {
  const { t, i18n } = useTranslation();
  const { isTablet } = useGlobal();

  const lang = i18n.language.startsWith('ru') ? 'ru' : 'en';
  const c = content[lang];

  return (
    <>
      <MobileHeaderLayout
        content={<MobileHeaderTitle text={t('returnAndExchange')} />}
      />
      <div className="content-layout">
        <div className={tp.root}>
          {!isTablet && (
            <Breadcrumbs
              items={
                [
                  { text: t('home'), link: '/' },
                  { text: t('returnAndExchange'), link: '/returns' },
                ].filter(Boolean) as BreadcrumbsItem[]
              }
            />
          )}

          <div className={tp.content}>
            <h1 className={tp.title}>{t('returnAndExchange')}</h1>

            <section className={tp.section}>
              <h2 className={tp.subtitle}>{c.conditionsTitle}</h2>
              <p className={tp.text}>{c.conditionsText}</p>
            </section>

            <section className={tp.section}>
              <h2 className={tp.subtitle}>{c.howTitle}</h2>
              <ol className={styles.orderedList}>
                {c.howSteps.map((step) => (
                  <li key={step} className={styles.orderedItem}>
                    {step}
                  </li>
                ))}
              </ol>
            </section>

            <section className={tp.section}>
              <h2 className={tp.subtitle}>{c.refundTitle}</h2>
              <p className={tp.text}>{c.refundText}</p>
            </section>

            <section className={tp.section}>
              <h2 className={tp.subtitle}>{c.exchangeTitle}</h2>
              <p className={tp.text}>{c.exchangeText}</p>
            </section>

            <section className={tp.section}>
              <h2 className={tp.subtitle}>{c.importantTitle}</h2>
              <p className={tp.text}>{c.importantText}</p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReturnsPage;
